module.exports = __webpack_public_path__ + "static/img/name1.96b1902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name1.png
// module id = FdJD
// module chunks = 1